import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirm Email Address',
  [OnboardingStep.StoreDetails]: 'Store details',
  [OnboardingStep.BusinessInfo]: 'Business details',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Add your store details',
  [OnboardingStep.PersonalInfo]: 'Add your personal information',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: "Owner's personal information",
  owner_personal_info_gmbh: 'Personal information of the owner / managing director',
  [OnboardingStep.ShippingInfo]: 'Add your delivery information',
  [OnboardingStep.BankInfo]: 'Add bank details for payouts',
  [OnboardingStep.TaxInfo]: 'Is your business VAT registered?',
  [OnboardingStep.BusinessDocs]: 'Proof of business document',
  [OnboardingStep.PersonalDocs]: 'Proof of identity document',
  [OnboardingStep.InfoSubmission]: 'Get paid',
  confirm_info_gateway: 'Get paid – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Payment info',
  [OnboardingStep.Subscription]: 'Subscription',
  [OnboardingStep.MobileApp]: 'Mobile app',
  [OnboardingStep.DeliveryStructure]: 'Delivery structure',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Contract payment',
  [OnboardingStep.Documents]: 'Upload documents',
  [OnboardingStep.PromoCode]: 'Promo code',
};
